/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author   Tomáš Burian    (burian@cadwork.cz)
 *
 */

import {RenderDocument} from "js_renderer";
import Picker from "./picker";
import IElement from "../../elements/element_interface";

export default
class ElementPicker extends Picker {
    private _pickedSceneAPIElement: IElement;

    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);

        this._pickedSceneAPIElement = null;
    }

    public getPickedSAPIElement(): IElement {
        return this._pickedSceneAPIElement;
    }

    public onClick(x: number, y: number, buttonState: number, aDraggedDuringClick: boolean) {
        if (!this._enabled || aDraggedDuringClick || this.isPaused()) {
            return false;
        }

        this._pickedSceneAPIElement = this.pickSceneElement([]);

        if (this._callbacks.onClick !== undefined) {
            this._callbacks.onClick(this._pickedSceneAPIElement);
        }
    }

    public onSingleTap(x: number, y: number) {
        if (!this._enabled || this.isPaused()) {
            return false;
        }

        this._pickedSceneAPIElement = this.pickSceneElement([]);
        if (this._callbacks.onClick !== undefined) {
            this._callbacks.onSingleTap(this._pickedSceneAPIElement);
        }
    }
}
